import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MenuComponent } from '../../shared/menu/menu.component';
import { RodapeComponent } from '../../shared/rodape/rodape.component';
import { ParceirosComponent } from '../../shared/parceiros/parceiros.component';
import { CarregamentoService } from '../../services/carregamento/carregamento.service';
import { MenuAcessibilidadeComponent } from '../../components/menu-acessibilidade/menu-acessibilidade.component';
import { LayoutPrincipalService } from './layout-principal.service';

@Component({
  selector: 'app-layout-principal',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    RouterOutlet,
    MenuComponent,
    RodapeComponent,
    ParceirosComponent,
    MenuAcessibilidadeComponent,
  ],
  templateUrl: './layout-principal.component.html',
  styleUrl: './layout-principal.component.scss',
})
export class LayoutPrincipalComponent implements OnInit {
  isLoading: boolean = false;
  currentRoute: string = '';

  mensagensCarregamento: string[] = [];

  constructor(
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private carregamentoService: CarregamentoService,
    private layoutPrincipalService: LayoutPrincipalService
  ) {
    // Subscribe detecta mudanças de rota a fim de atualizar currentRoute
    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
    });
  }

  ngOnInit(): void {
    // Definindo rota inicial
    this.currentRoute = this.router.url;

    this.layoutPrincipalService.mensagensCarregamento.subscribe((mensagens) => {
      this.mensagensCarregamento = mensagens;
      this.changeDetectorRef.detectChanges();
    });

    this.carregamentoService.loading$.subscribe((loading) => {
      this.isLoading = loading;
      this.changeDetectorRef.detectChanges();
    });
  }
}
